// Unique ID for this browser tab, shared across all components that use BroadcastChannel
export const TAB_ID = Math.random().toString(36).slice(2);
